exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-upload {\n  position: relative;\n}\n.cube-upload-def {\n  margin-right: -2.66667vw;\n}\n.cube-upload-def .cube-upload-btn,\n.cube-upload-def .cube-upload-file {\n  float: left;\n  margin: 0 2.66667vw 2.66667vw 0;\n}\n", ""]);

// exports
